import { styled } from '@/theme/index';
import { Text } from '../Text/Text';

export const ErrorTitle = styled(Text)`
  color: #ef2742;
  font-size: 20px;
`;

type Props = { message: string };

export const ErrorMessage = ({ message }: Props) => {
  if (message) {
    return <ErrorTitle>{message}</ErrorTitle>;
  }
  return <ErrorTitle>Oops... something didn't work</ErrorTitle>;
};
